<template>
  <div>
    <div
      class="align-items-end d-flex p-0 custom-radio-container"
      v-if="options !== undefined && options.length > 0"
    >
      <div v-for="(item, indx) in options" :key="indx" @click="Change(item)">
        <div
          :class="
            item.invalid == true
              ? 'bg-error'
              : disabled && item.check
              ? 'bg-dark-gray'
              : item.check == true
              ? 'bg-green'
              : 'bg-gray-radio'
          "
          class="text-center pointer rounded-top mb-0 custom-radio-button full-div"
        >
          <div class="radio">
            <label class="w-100 mb-0">
              <input
                :id="`${id}-${indx}`"
                :name="item.name + '-' + indx"
                type="radio"
                :value="item.value"
                @input="updateValue($event.target.value)"
                :disabled="disabled || item.disabled"
              />
              <span class="cr rounded-circle pointer">
                <i
                  v-if="!item.icon"
                  :class="item.check == true ? 'fa fa-check check-opacity' : ''"
                  class="cr-icon"
                ></i>
              </span>
            </label>
          </div>
          <i
            v-if="item.icon"
            :class="item.icon"
            :style="{
              color:
                item.check == true
                  ? 'white'
                  : item.iconColor
                  ? item.iconColor
                  : '#ff7058',
            }"
          ></i>
          <span class="step-label">{{ item.label }}</span>
        </div>

        <div
          :class="
            item.invalid == true
              ? 'bg-error'
              : item.check == true
              ? 'bg-green'
              : 'bg-gray'
          "
          class="text-center pointer rounded-top mb-0 custom-radio-button-mobile mobile-div"
        >
          <div class="radio">
            <label class="w-100 mb-0">
              <input
                :id="`${id}-${indx}`"
                :name="item.name + '1-' + indx"
                type="radio"
                :value="item.value"
                @input="updateValue($event.target.value)"
                :disabled="disabled || item.disabled"
              />
              <span class="cr rounded-circle pointer"></span>
            </label>
          </div>
          <span class="step-label-mobile">{{ item.label }}</span>
        </div>
      </div>
    </div>
    <div class="error">
      <error
        v-if="error"
        variant="no-border"
        :message="customErrorMsg"
        class="mt-1 "
      />
    </div>
  </div>
</template>
<script>
import Error from 'custom-error';

export default {
  name: 'CustomRadio',
  meta: {
    description:
      'Componente común CustomRadio personalizado y CustomRadioButton, sólido.',
    slots: {
      default: {
        type: 'component',
        valid: [],
      },
    },
  },
  components: {
    Error,
  },
  data() {
    return {};
  },
  props: {
    isQuestionList: {
      type: [Boolean],
      default: false,
      meta: {
        description: 'Parámetro de entrada del CustomRadio',
      },
    },
    value: {
      type: [String, Boolean, Number],
      default: '',
      meta: {
        description: 'Parámetro de entrada del CustomRadio',
        example: '',
      },
    },
    options: {
      type: [Array, Object],
      default: () => [],
      meta: {
        description: 'Posibilita elegir entre varios artículos',
        example: '"[4, 8, 15, 16, 23, 42]',
      },
    },
    label: {
      type: String,
      default: '',
      meta: {
        description: 'Control para mostrar texto',
        example: 'Texto requerido',
      },
    },
    name: {
      type: String,
      default: '',
      meta: {
        description: 'Estable el nombre del radio',
        example: 'Texto requerido',
      },
    },
    error: {
      type: Boolean,
      default: false,
      meta: {
        description: 'Estado Error',
        example: 'Texto requerido',
      },
    },
    customErrorMsg: {
      type: String,
      default: function() {
        return this.error;
      },
      meta: {
        description: 'Mensaje de error encontrado',
        example: 'Texto requerido',
      },
    },
    isInline: {
      type: Boolean,
      default: false,
      meta: {
        description: 'Establece que está en línea',
        example: 'true',
      },
    },
    disabled: {
      type: Boolean,
      default: false,
      meta: {
        description: 'Estado disabled',
        example: 'true',
      },
    },
    containerClass: {
      type: String,
      default: '',
    },
    computed: {
      isValid() {
        return !this.error && this.dirty;
      },
    },
    id: {
      type: String,
      default: 'rbtnRadioButton',
      meta: {
        description: 'Id del Componente CustomRadioButton',
        example: 'IdCustomRadioButton',
      },
    },
    changeEvent: {
      type: Function,
      default: () => {},
      meta: {
        description: 'Evento que se dispara al seleccionar una opción',
        example: '',
      },
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    updateValue(value) {
      if (value === 'true') {
        this.$emit('input', true);
      } else if (value === 'false') {
        this.$emit('input', false);
      } else {
        this.$emit('input', value);
      }
    },
    async Change(item) {
      this.options;
      let self = this;
      if (this.disabled) {
        return;
      }
      await self.options.map((val) => {
        if (val.label == item.label) {
          val.check = true;
        } else {
          val.check = false;
        }
      });

      self.invalid = !self.options.some((elem) => elem.check == true);
      self.changeEvent(item);
    },
  },
  watch: {
    value(value) {
      this.$emit('input', value);
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/assets/scss/variables/_colors.scss';

p.text-left.d-inline {
  font-size: 110px !important;
}

.custom-control-input,
.custom-control-label {
  cursor: pointer;
}

.custom-control-input:checked.custom-control-input:checked:disabled
  ~ .custom-control-label::before {
  color: #fff;
  border-color: #2db782;
  background-color: #2db782;
}

.custom-control-input.invalid ~ .custom-control-label::before {
  background-color: #f7d7da;
  border-color: #e85c5c;
}

.sucess-icon {
  font-size: 19px;
  position: absolute;
  top: 9px;
  right: 7px;
  color: #3f5b60;
  margin-right: 0.2rem;
}

.sucess-icon:before {
  content: '\f058';
  color: #2db782;
}

div.invalid:not(input) {
  color: #e85c5c;
}

.form-control-icon-normal {
  position: absolute;
  top: 9px;
  right: 10px;
  color: #3f5b60;
  margin-right: 0.2rem;
}

.icon-invalid {
  color: #e85c5c;
}

.custom-error i {
  float: left;
  margin-top: 15px;
  margin-right: 10px;
  color: #e85c5c;
}

.custom-control-label.invalid::before {
  border-color: #e85c5c;
  border-width: 2px;
  background: #f7d7da;
}

/* Inicio custom radio Button */
@media (max-width: 375px) {
  .full-div {
    display: none !important;
  }

  .custom-radio-button-mobile.mobile-div {
    display: block !important;
  }
}

.mobile-div {
  display: none !important;
}

.bg-error {
  background: #ffebeb 0% 0% no-repeat padding-box !important;
  border: 1px solid #c9545e !important;
  border-radius: 5px 5px 0px 0px;
  opacity: 1;
}

.bg-error .rounded-circle {
  border: 2px solid #c9545e !important;
  opacity: 1;
}

.bg-error .step-label {
  text-align: center;
  font: Regular 11px/13px Lato;
  letter-spacing: 0;
  color: #c9545e;
  opacity: 1;
}

.bg-error .step-label-mobile {
  text-align: center;
  font: Regular 8px/8px Lato;
  letter-spacing: 0;
  color: #c9545e;
  opacity: 1;
}

.pointer {
  cursor: pointer;
}

.question {
  box-shadow: -3px 1px 3px #00000029;
  align-content: space-between;
}

.bg-gray-radio {
  background: map-get($colors, 'secondary-9');
}

.bg-green {
  background: #2db782;
}

/************* start of custom radio *****************/
.radio label:after {
  content: '';
  display: table;
  clear: both;
}

.radio .cr {
  position: relative;
  display: inline-block;
  border: 2px solid #a9a9a9;
  border-radius: 0.25em;
  width: 1.2em;
  height: 1.2em;
  margin-top: 4px;
}

.cr {
  border-radius: 50%;
}

.radio .cr .cr-icon {
  position: absolute;
  font-size: 0.7em;
  line-height: 0;
  top: 53%;
  left: 13%;
}

.cr-icon {
  margin-top: 0.04em;
}

.radio label input[type='radio'] {
  display: none;
}

.radio label input[type='radio'] + .cr > .cr-icon {
  opacity: 0;
}

.radio label input[type='radio']:checked + .cr > .cr-icon {
  opacity: 1;
}

.radio label input[type='radio']:disabled + .cr {
  border: 2px solid #aab7b1;
}

.radio label input[type='radio']:disabled + .cr > .cr-icon {
  color: #aab7b1 !important;
}
.radio label input[type='radio'] + .cr > .cr-icon {
  color: #fff !important;
}

.rounded-top {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

/************* end of custom radio *****************/

label,
p {
  font-weight: normal;
}

.step-label {
  display: block;
  font: Regular 11px/11px Lato;
  font-size: 12px;
  letter-spacing: 0;
  color: #aab7b1;
  font-weight: 100;
}

.step-label-mobile {
  display: block;
  font: Regular 8px/8px Lato;
  font-size: 8px;
  letter-spacing: 0;
  color: #c9c9c9;
  font-weight: 100;
}

.bg-green .step-label,
.bg-green .step-label-mobile {
  color: white;
}

.bg-green .radio .w-100 .cr.rounded-circle {
  border: 2px solid white;
  opacity: 1;
}

.step-label.active {
  color: #2db782;
  font-weight: bold;
}

.error-val {
  color: #ff5b5c;
  display: block;
  padding-left: 25px;
}

.success-val {
  color: #2db782;
  display: block;
}

.warning-val {
  color: #af6708;
  display: block;
}

.question-number-sup {
  font: 21px Lato;
  letter-spacing: 0;
  color: #ffffff;
}

.custom-control-label.font {
  font: 400 16px/19px Lato;
  color: #11291b;
  padding-top: 4px;
}

.custom-radio-container .custom-radio-button {
  width: 70px;
  margin-right: 8px;
  padding: 7px;
}

.custom-radio-container .custom-radio-button-mobile {
  width: 30px;
  margin-right: 3px;
}

.check-opacity {
  opacity: 1 !important;
}
</style>
